import {
  GET_VEHICLE,
  GET_ADDVEHICLE,
  GET_DELETEVEHICLE,
  GET_UPDATEVEHICLE,
  GET_MATRIXVEHICLE,
  GET_MOREVEHICLE,
} from "resources/actionTypes";

export function getVehicle(data) {
  return {
    type: GET_VEHICLE.GET_VEHICLE_REQUESTED,
    payload: data
  };
}

export function postAddVehicle(userAddVehicle) {
  const data = {
    userAddVehicle: userAddVehicle,
  }
  return {
    type: GET_ADDVEHICLE.GET_ADDVEHICLE_REQUESTED,
    payload: data,
  };
}

export function patchUpdateVehicle(userUpdateVehicle) {
  const data = {
    userUpdateVehicle: userUpdateVehicle,
  }
  return {
    type: GET_UPDATEVEHICLE.GET_UPDATEVEHICLE_REQUESTED,
    payload: data,
  };
}

export function deleteVehicle(userDeleteVehicle) {
  const data = {
    userDeleteVehicle: userDeleteVehicle,
  }
  return {
    type: GET_DELETEVEHICLE.GET_DELETEVEHICLE_REQUESTED,
    payload: data,
  };
}

export function getMatrixVehicle(data) {
  return {
    type: GET_MATRIXVEHICLE.GET_MATRIXVEHICLE_REQUESTED,
    payload: data,
  };
}

export function getMoreVehicle(data) {
  return {
    type: GET_MOREVEHICLE.GET_MOREVEHICLE_REQUESTED,
    payload: data,
  };
}

